module.exports = __webpack_public_path__ + "static/assets/d09e41a06c2900bd495bce9f215c4f2f.svg";